module.exports = __webpack_public_path__ + "img/jzy_problem_01.d541a179.png";